import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });
// Sesión solo por cookie httpOnly (nada de tokens en localStorage — XSS-safe)

export default api;

export function fmtEUR(v) {
  if (v === null || v === undefined) return "—";
  return new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR" }).format(v);
}

export function fmtNum(v) {
  if (v === null || v === undefined) return "—";
  return new Intl.NumberFormat("es-ES").format(v);
}

export function fmtDate(d) {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleDateString("es-ES", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return d;
  }
}
